import { useMediaQuery } from "@mui/material";
import { BREAKPOINTS } from "../styles/constants.style";

const parsePx = (val: string) => parseInt(val.replace("px", ""), 10);

export const useMediaQueries = () => {
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.MOBILE})`);

  const isTabletPortrait = useMediaQuery(
    `(min-width: ${parsePx(BREAKPOINTS.MOBILE) + 1}px) and (max-width: ${BREAKPOINTS.TABLET_PORTRAIT})`
  );

  const isTablet = useMediaQuery(
    `(min-width: ${parsePx(BREAKPOINTS.MOBILE ) + 1}px) and (max-width: ${BREAKPOINTS.TABLET_LANDSCAPE})`
  );

  const isSmallScreen = useMediaQuery(`(max-width: ${BREAKPOINTS.TABLET_PORTRAIT})`);

  const isWideEnough = useMediaQuery(`(min-width: ${BREAKPOINTS.DESKTOP})`);
  const hasFinePointer = useMediaQuery(`(pointer: fine)`);
  const isRealDesktop = isWideEnough && hasFinePointer;

  return {
    // New
    isMobile,
    isTablet,
    isTabletPortrait,

    // Original logic support
    isSmallScreen,
    isRealDesktop,
  };
};
